import { getImageUrl } from 'lib/image/imageUtils'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

const StyledImage = styled.img`
  object-fit: cover;
  object-position: center;
  margin: auto;
  width: ${rem(24)};
  height: ${rem(24)};
  border-radius: ${props => props.theme.borderRadius.round};
`

interface Props {
  width?: number
  height?: number
}

function AgentAvatar({
  width = 24,
  height = 24,
}: Props) {
  const imageUrl = getImageUrl('d5sfjdbpg47k0yfcxxzj', {
    width,
    height,
    format: 'jpg',
    quality: 'best',
    highRes: true,
  })

  return (
    <StyledImage src={imageUrl} />
  )
}

export default AgentAvatar
